var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function CompaniesGrid(el) {
  var $el = $(el),
      $activeItem = null,
      $activeSlide = null,
      $window = $( window ),
      $header = $('.header'),
      $items = $el.find('.explain__item'),
      $filters = $el.find('.companies-grid__filter select'),
      $cells = $el.find('.companies-cell');

  if ( $filters.length ) {
    $filters.on('change', function() {
      var $matched = $cells;

      $filters.each(function(index, filter) {
        var selected = filter.value;

        if (selected === '0') {
          return;
        }

        $matched = $matched.filter('[data-filter*="' + selected + '"]');
      });

      $matched.show();
      $cells.not($matched).hide();
    });
  }

  $items.on('click', '.companies-cell__logo', function(e) {
    console.log('yo!');
    var $item = $(this).closest( '.explain__item' ),
        $img = $item.find('.explain__img'),
        $desc = $item.find('.explain__content'),
        $close = $item.find('.explain__close-item'),
        itemTop = $item.offset().top;

    e.preventDefault();

    if ( !$activeSlide ) {
      showContent();
    } else {
      if ( ! $item.hasClass( 'js-cell-active' ) ) {
        activeItemTop = $activeItem.offset().top;
        if ( activeItemTop == itemTop ) {
          console.log($activeSlide);
          $activeSlide.fadeOut({ duration: 300, progress: resetHeight });
          $desc.fadeIn({ duration: 300, progress: setHeight });
        } else {
          resetHeight();
          $activeSlide.slideUp({ duration: 300, progress: removeHeight });
          $activeItem.removeClass('js-cell-active');
          $activeItem.siblings().css( 'opacity', '');
          showContent();
        }
        $activeItem.removeClass( 'js-cell-active' );
        $activeItem.siblings().css( 'opacity', '');
        showContent();
      }
    }
    $item.addClass( 'js-cell-active' );
    $item.siblings().css( 'opacity', '0.6');

    $activeItem = $item;
    $activeSlide = $desc;

    $close.off('click').on('click', function(e) {
      e.preventDefault();

      $desc.slideUp({ duration: 300, progress: removeHeight, complete: function() {
        $item.css('height', '');
        $item.removeClass('js-cell-active');
        $item.siblings().css( 'opacity', '');
      } });
    });

    function showContent() {
      scrollTopPosition = itemTop - ( $window.width() > 1024 ? $header.outerHeight() : 0 );
      if( $activeItem && itemTop > activeItemTop ) {
        scrollTopPosition -= $activeSlide.height();
      }

      $('body, html').animate({
        scrollTop: scrollTopPosition
      }, 300);

      $item.addClass('js-cell-active');
      $item.siblings().css( 'opacity', '0.6');
      $desc.slideDown({ duration: 300, progress: setHeight });
    }

    function hideContent() {
      $item.removeClass('js-cell-active');
      $item.siblings().css( 'opacity', '');
      $desc.slideUp({ duration: 300, progress: removeHeight });
    }

    function removeHeight() {
      var $activeItem = $item;
      $item.height($img.outerHeight() + $desc.outerHeight() + 40);
    }

    function setHeight() {
      $item.height($img.outerHeight() + $desc.outerHeight() + 40);
    }

    function resetHeight() {
      $items.height('auto');
    }

  });

};

module.exports = CompaniesGrid;
